<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" style="margin-right: 2rem">
        <img
          src="@/assets/beamian-logo-white.png"
          class="logo"
          width="112"
          height="28"
        />
      </a>
      <a
        role="button"
        class="navbar-burger burger"
        :class="{ 'is-active': isMenuOpen }"
        aria-label="menu"
        :aria-expanded="isMenuOpen ? 'true' : 'false'"
        data-target="navbarMenu"
        @click="toggleMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarMenu" class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
      <div class="navbar-start">
        <router-link class="navbar-item" to="/" exact>
          <span class="menu-item-text">Home</span>
        </router-link>
        <router-link class="navbar-item" to="/events">
          <span class="menu-item-text">{{ translations.events }}</span>
        </router-link>
        <router-link class="navbar-item" to="/devices">
          <span class="menu-item-text">{{ translations.devices }}</span>
        </router-link>
        <router-link class="navbar-item" to="/spaces">
          <span class="menu-item-text">Spaces</span>
        </router-link>
        <router-link class="navbar-item" to="/users">
          <span class="menu-item-text">{{ translations.users }}</span>
        </router-link>
        <router-link class="navbar-item" to="/accounts">
          <span class="menu-item-text">Accounts</span>
        </router-link>
        <router-link class="navbar-item" to="/plans">
          <span class="menu-item-text">Plans</span>
        </router-link>
        <router-link class="navbar-item" to="/sms">
          <span class="menu-item-text">SMS</span>
        </router-link>
        <router-link class="navbar-item" to="/platform-invoicing">
          <span class="menu-item-text">Invoicing</span>
        </router-link>
      </div>

      <div class="navbar-end">
        <a
          @click="changeLanguage('pt')"
          class="navbar-item"
          :class="{ 'has-text-weight-bold': language === 'pt' }"
          >PT</a
        >
        <a
          @click="changeLanguage('en')"
          class="navbar-item"
          style="margin-right: 1rem"
          :class="{ 'has-text-weight-bold': language === 'en' }"
          >EN</a
        >

        <router-link
          class="navbar-item tooltip is-tooltip-left"
          :data-tooltip="translations.logout"
          to="/logout"
        >
          <span class="material-icons">logout</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

import { ICommonTranslations } from '../translations';

@Component({
  name: 'Navbar',
})
class Navbar extends Vue {
  @Mutation('setLanguage') public setLanguage!: (lang: 'pt' | 'es' | 'en') => void;

  @Getter('getCommonTranslations') public translations!: ICommonTranslations;

  @Getter('getLanguage') public language!: 'es' | 'pt' | 'en';

  public isMenuOpen = false;

  public toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Collapse the mobile menu after navigating to a new route.
  @Watch('$route')
  public onRouteChange() {
    this.isMenuOpen = false;
  }

  public changeLanguage(lang: 'pt' | 'es' | 'en') {
    const localStorageLangProp = process.env.VUE_APP_LOCAL_STORAGE_LANG_PROP;
    localStorage.setItem(localStorageLangProp, lang);
    this.setLanguage(lang);
  }
}

export default Navbar;
</script>
<style lang="scss">
@import "./src/bulma/components/navbar";
@import "./src/bulma/elements/image";
@import "./src/bulma/elements/icon";
@import "./src/bulma/components/dropdown";

.navbar {
  padding: 0 1rem 0;
  .navbar-start .dropdown-trigger {
    display: flex;
    align-content: center;
    align-items: center;
  }
  .navbar-item {
    cursor: pointer;
    .icon {
      margin-right: 0.1rem;
    }
  }

  .notifications-item {
    cursor: pointer;
  }
  .user-item {
    padding: 0 0.75rem;
    cursor: pointer;
    .image {
      width: 2.1rem;
      img {
        border: 1px solid $border;
        max-height: none;
        opacity: 0.9;
      }
    }
  }
  .field {
    margin: 0.76rem 1rem;
    .input {
      width: 20rem;
      &:focus {
        + .icon {
          color: $grey-darker;
        }
      }
    }
    .icon {
      color: $grey;
    }
  }
}

// .logo {
//   filter: invert(1);
//   opacity: 0.8;
// }
</style>